import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { readBibleChapter, readBibleIndex } from "./bible.server";
import { readDocumentPage } from "./document.server";
import { siteContext } from "./site.server";

/** /bible in one request: the composed page with its chapter list, or where the Bible begins. */
export const loadBible = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readBibleIndex(await siteContext(context)),
);

/**
 * One League Bible chapter, authorized for this visitor. With the Bible off, /bible/<page> is a
 * page of the creator's own instead, served like any other.
 */
export const loadBibleChapter = createServerFn({ method: "GET" })
  .validator((key: unknown) => {
    if (typeof key !== "string" || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(key) || key.length > 80)
      throw notFound();
    return key;
  })
  .handler(async ({ data: key, context }) => {
    const site = await siteContext(context);
    const chapter = await readBibleChapter(site, key);
    if (chapter) return { kind: "chapter" as const, ...chapter };
    const page = await readDocumentPage(site, `/bible/${key}`);
    return page.kind === "missing" ? null : page;
  });
